import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'li[py-order-entry-list-item-loading]',
  templateUrl: './order-entry-list-item-loading.component.html',
  styleUrls: ['./order-entry-list-item-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderEntryListItemLoadingComponent {}
